import http, {RequestOptions, unwrap} from "@/api/http";
import {CreateUserInput, UpdateUserInput, UserDto} from "@/api/types";

export interface ListUsersParams {
    /** Matches name or email, case-insensitively. */
    q?: string;
}

/** `GET /api/users?q=` (#2, admin) */
export const listUsers = (params: ListUsersParams = {}, options?: RequestOptions): Promise<UserDto[]> =>
    http.get<UserDto[]>("/users", {...options, params}).then(unwrap);

/** `GET /api/users/{id}` (#3, admin). 404 if unknown. */
export const getUser = (id: number, options?: RequestOptions): Promise<UserDto> =>
    http.get<UserDto>(`/users/${id}`, options).then(unwrap);

/** `POST /api/users` (#4, admin). 201; 409 `USER_EMAIL_TAKEN` if the email exists. */
export const createUser = (input: CreateUserInput, options?: RequestOptions): Promise<UserDto> =>
    http.post<UserDto>("/users", input, options).then(unwrap);

/** `PUT /api/users/{id}` (#5, admin). Changes only `isAdmin` and `partnerId`; 404 if unknown. */
export const updateUser = (id: number, input: UpdateUserInput, options?: RequestOptions): Promise<UserDto> =>
    http.put<UserDto>(`/users/${id}`, input, options).then(unwrap);
